import { MarkerType } from "../../store";

// SVG of a created (marker editor) icon, with its dynamic text filled in
export function markerSvgMarkup(marker: MarkerType, number = "1", letter = "A"): string {
  return atob(marker.base64.split(',')[1])
    .replace('__SPACE_NUMBER__', number)
    .replace('__SPACE_LETTER__', letter)
    .replace('__SPACE_LETTER_LOWER__', letter.toLowerCase());
}

export function Icon(
  { marker, number="1", letter="A", className="", style={} }:
  { marker: MarkerType, number: string, letter: string, className?: string, style?: React.CSSProperties })
{
  // Show created icons as SVG
  if (marker.state) {
    // TODO: Other CSS could affect the icons
    // TODO sanitize svgString?
    const svgString = markerSvgMarkup(marker, number, letter);

    return (
      <span
        className={className}
        style={{
          height: '100%',
          width: '100%',
          ...style,
        }}
        dangerouslySetInnerHTML={{ __html: svgString }}
      />
    );
  }

  return (
    <img
      src={marker.base64 || marker.url}
      alt=""
      style={ style }
      className={className}
    />
  );
}
